var _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _text, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgByte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10h30v30",
    stroke: "#3D4F66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190 10h-30v30",
    stroke: "#3D4F66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 190h30v-30",
    stroke: "#3D4F66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M190 190h-30v-30",
    stroke: "#3D4F66"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 60,
    x2: 10,
    y2: 80,
    stroke: "#42D7F5"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 60,
    x2: 30,
    y2: 80,
    stroke: "#42D7F5"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 60,
    x2: 50,
    y2: 80,
    stroke: "#42D7F5"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 60,
    x2: 70,
    y2: 80,
    stroke: "#42D7F5"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 60,
    x2: 130,
    y2: 80,
    stroke: "#42D7F5"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 60,
    x2: 150,
    y2: 80,
    stroke: "#42D7F5"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 60,
    x2: 170,
    y2: 80,
    stroke: "#42D7F5"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 60,
    x2: 190,
    y2: 80,
    stroke: "#42D7F5"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 140,
    x2: 10,
    y2: 160,
    stroke: "#42D7F5"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 140,
    x2: 30,
    y2: 160,
    stroke: "#42D7F5"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 140,
    x2: 50,
    y2: 160,
    stroke: "#42D7F5"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 140,
    x2: 70,
    y2: 160,
    stroke: "#42D7F5"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 140,
    x2: 130,
    y2: 160,
    stroke: "#42D7F5"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 140,
    x2: 150,
    y2: 160,
    stroke: "#42D7F5"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 140,
    x2: 170,
    y2: 160,
    stroke: "#42D7F5"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 140,
    x2: 190,
    y2: 160,
    stroke: "#42D7F5"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 125,
    fontSize: 30,
    fill: "#00D6CB",
    fontFamily: "monospace",
    fontWeight: "bold"
  }, "\n\t\tBYTE\n\t")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7,
    fill: "#FF4C5B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 10,
    r: 7,
    fill: "#FF4C5B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 190,
    r: 7,
    fill: "#FF4C5B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 190,
    r: 7,
    fill: "#FF4C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgByte);
export default __webpack_public_path__ + "static/media/byte.d2a25ebc07c8adee7955bcd3bcaf1dc0.svg";
export { ForwardRef as ReactComponent };